import { Pages } from '@briq/core'
import { Containers } from '@briq/core'

export function useCartConfig(): Pages.CartConfig {
  return {
    hideInvestigationFormLink: false,
    manyCartItems: Containers.Cart.CartTable
  }
}
